export default __webpack_public_path__ + "static/media/icon-input-error.580ee1b3.svg";